/**
 * Plugin de tema dinámico para Vuetify 2
 * Lee colores y modo oscuro desde localStorage (sincronizados desde ajustes de BD)
 * y los aplica reactivamente al tema de Vuetify.
 */

const DEFAULT_COLORS = {
  primary:   '#1706FF',
  secondary: '#0D47A1',
  accent:    '#00BCD4',
}

export function aplicarTema(vuetifyInstance, ajustes) {
  if (!vuetifyInstance || !ajustes) return

  const primario   = ajustes.color_primario   || DEFAULT_COLORS.primary
  const secundario = ajustes.color_secundario || DEFAULT_COLORS.secondary
  const acento     = ajustes.color_acento     || DEFAULT_COLORS.accent
  const oscuro     = !!(parseInt(ajustes.modo_oscuro))

  // Aplicar al tema de Vuetify (reactivo)
  vuetifyInstance.theme.themes.light.primary   = primario
  vuetifyInstance.theme.themes.light.secondary = secundario
  vuetifyInstance.theme.themes.light.accent    = acento
  vuetifyInstance.theme.themes.dark.primary    = primario
  vuetifyInstance.theme.themes.dark.secondary  = secundario
  vuetifyInstance.theme.themes.dark.accent     = acento
  vuetifyInstance.theme.dark = oscuro

  // Persistir en localStorage para carga rápida al inicio
  localStorage.setItem('tema_primario',   primario)
  localStorage.setItem('tema_secundario', secundario)
  localStorage.setItem('tema_acento',     acento)
  localStorage.setItem('modo_oscuro',     oscuro ? '1' : '0')
}

export function cargarTemaGuardado(vuetifyInstance) {
  if (!vuetifyInstance) return
  const primario   = localStorage.getItem('tema_primario')   || DEFAULT_COLORS.primary
  const secundario = localStorage.getItem('tema_secundario') || DEFAULT_COLORS.secondary
  const acento     = localStorage.getItem('tema_acento')     || DEFAULT_COLORS.accent
  const oscuro     = localStorage.getItem('modo_oscuro') === '1'

  vuetifyInstance.theme.themes.light.primary   = primario
  vuetifyInstance.theme.themes.light.secondary = secundario
  vuetifyInstance.theme.themes.light.accent    = acento
  vuetifyInstance.theme.themes.dark.primary    = primario
  vuetifyInstance.theme.themes.dark.secondary  = secundario
  vuetifyInstance.theme.themes.dark.accent     = acento
  vuetifyInstance.theme.dark = oscuro
}

export function toggleModoOscuro(vuetifyInstance) {
  vuetifyInstance.theme.dark = !vuetifyInstance.theme.dark
  localStorage.setItem('modo_oscuro', vuetifyInstance.theme.dark ? '1' : '0')
}

export default { aplicarTema, cargarTemaGuardado, toggleModoOscuro }



// WEBPACK FOOTER //
// ./src/plugins/tema.js